<footer class="footer">
  <div class="footer-text">
    CDeP3 - COORDENADORIA PROFISSIONAL E PRÃTICAS PEDAGÃGICAS
  </div>

  <div class="social-container">
    <span class="social-title">SIGA-NOS NAS REDES SOCIAIS</span>
    <div class="social-links">
      <a href="https://www.facebook.com/cdep3unesp" target="_blank">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="https://www.youtube.com/c/IEP3Unesp" target="_blank">
        <i class="fab fa-youtube"></i>
      </a>
      <a href="https://instagram.com/cdep3unesp" target="_blank">
        <i class="fab fa-instagram"></i>
      </a>
    </div>
  </div>
</footer>
